import "./header.css";

const Header = () => {
  return (
    <header className="header container">
      <h1>Fast React Pizza Co.</h1>
    </header>
  );
};

export default Header;
